<template lang="pug">
v-container.py-8.py-sm-10.d-flex.flex-column.align-center.px-0
  grid-container.align-center(
    cols="auto",
    cols-md="340px 400px",
    gap-md="80px",
    rows-md="420px"
  )
    .px-4.px-md-0
      .text-h4.font-weight-bold.primary--text(v-html="title")
      .text-body-1.font-weight-bold.mt-3(v-html="content.intro")
      v-btn.font-weight-bold.text-none.px-8(
        :to="path",
        color="primary",
        depressed
      ) Ver mais
    .page-home-jeanpiaget-picture.mt-4
      img(:src="files + content.mainImg")
      .page-home-jeanpiaget-rectangle
</template>

<script>
const _config = {
  title: "JEAN PIAGET<br>(1896-1980)",
  mod: "jeanPiaget",
  path: "/institucional/quem-foi-jean-piaget",
};

export default {
  data: () => ({
    title: _config.title,
    path: _config.path,
  }),
  computed: {
    content() {
      return this.$rest(_config.mod).item;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
};
</script>

<style>
.page-home-jeanpiaget-picture {
  position: relative;
  width: 100%;
  height: 100%;
}
.page-home-jeanpiaget-picture img {
  position: absolute;
  left: 60px;
  bottom: 30px;
  width: 320px;
  z-index: 9;
}
.page-home-jeanpiaget-rectangle {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 80%;
  width: 100%;
  background: var(--v-primary-base);
}
@media screen and (max-width: 960px) {
  .page-home-jeanpiaget-picture {
    height: 400px;
  }
  .page-home-jeanpiaget-picture img {
    width: 85%;
    max-height: 100%;
    object-fit: contain;
    left: 30px;
    bottom: 15px;
  }
}
</style>
